/* ISG personaliser, part 2 of 5 (built by tools/split.js from isg-personaliser.js md5 aceaaca6061588d0d715ab3ec4d20473; load after part 1). */
(function (root) {
  'use strict';
  var NS = root.__isgPz;
  if (!NS || NS.__parts !== 1) { if (root.console) root.console.error('ISG personaliser: part 2 loaded before part 1'); return; }
  var money = NS.money, round1 = NS.round1, fitToTier = NS.fitToTier, clampBox = NS.clampBox, clampToBounds = NS.clampToBounds, stageBounds = NS.stageBounds, splitBody = NS.splitBody, garmentFit = NS.garmentFit, parseCmPair = NS.parseCmPair, parseSizedPairs = NS.parseSizedPairs, bagPlace = NS.bagPlace, endPlace = NS.endPlace, bagBody = NS.bagBody, headwearFit = NS.headwearFit, legFit = NS.legFit, hivisFit = NS.hivisFit, apronFit = NS.apronFit, bagFit = NS.bagFit, chestZone = NS.chestZone, pctBoxToCm = NS.pctBoxToCm, boxBlur = NS.boxBlur, median = NS.median, lsq3 = NS.lsq3;


  /*
   * Make a back view from a flat front packshot (RGBA pixels on a plain background): the neck opening,
   * the inside label and the front collar are covered with fabric that blends in, and a back collar
   * stitch line is added. Returns { overlay } — RGBA to draw over the photo (alpha = where it changed) —
   * or null when the photo doesn't look like a front view of a top it can work on.
   */
  function backFromFront(data, w, h) {
    var N = w * h, x, y, i, k;
    function px(xx, yy, c) { return data[(yy * w + xx) * 4 + c]; }
    var cs = [[2, 2], [w - 3, 2], [2, h - 3], [w - 3, h - 3]], bg = [0, 1, 2].map(function (c) {
      var v = cs.map(function (p) { return px(p[0], p[1], c); }).sort(function (a, b) { return a - b; }); return (v[1] + v[2]) / 2;
    });
    var fg = new Uint8Array(N), lum = new Float32Array(N);
    for (i = 0; i < N; i++) {
      var r = data[i * 4], g = data[i * 4 + 1], b = data[i * 4 + 2];
      fg[i] = Math.abs(r - bg[0]) + Math.abs(g - bg[1]) + Math.abs(b - bg[2]) > 36 ? 1 : 0;
      lum[i] = 0.299 * r + 0.587 * g + 0.114 * b;
    }
    var top = -1, bot = -1;
    for (y = 0; y < h; y++) { var n = 0; for (x = 0; x < w; x++) n += fg[y * w + x]; if (n > 2) { if (top < 0) top = y; bot = y; } }
    if (top < 0) return null;
    var gh = bot - top, cx = Math.floor(w / 2);
    if (gh < h * 0.3) return null;
    var ym = Math.floor(top + gh * 0.5), bl = cx, br = cx;
    if (!fg[ym * w + cx]) return null;
    while (bl > 0 && fg[ym * w + bl - 1]) bl--;
    while (br < w - 1 && fg[ym * w + br + 1]) br++;
    var bw = br - bl + 1;
    if (bw < w * 0.2) return null;
    var L = boxBlur(lum, w, h, 2);
    var chest = [];
    for (y = Math.floor(top + gh * 0.3); y < Math.floor(top + gh * 0.4); y++) for (x = cx - Math.floor(bw / 8); x < cx + Math.floor(bw / 8); x++) chest.push(L[y * w + x]);
    var Lf0 = median(chest), mean = chest.reduce(function (a, v) { return a + v; }, 0) / chest.length;
    var sd = Math.sqrt(chest.reduce(function (a, v) { return a + (v - mean) * (v - mean); }, 0) / chest.length);
    var tol = Math.max(4, 3 * sd);
    var ylim = Math.floor(top + gh * 0.32), rib = Math.max(3, Math.floor(gh * 0.028)), run = Math.max(4, Math.floor(gh * 0.012)), BIG = 1e9;
    var E = new Float64Array(w), Es = new Float64Array(w);
    for (x = 0; x < w; x++) { E[x] = BIG; for (y = top; y < ylim; y++) if (fg[y * w + x]) { E[x] = y; break; } }
    for (x = 0; x < w; x++) Es[x] = (x >= 2 && x < w - 2) ? median([E[x - 2], E[x - 1], E[x], E[x + 1], E[x + 2]]) : E[x];
    function neckPoint(step) {
      var xx = cx, best = xx;
      while (xx > 0 && xx < w - 1 && Math.abs(xx - cx) < bw * 0.45) {
        xx += step;
        if (Es[xx] < Es[best]) best = xx;
        else if (Es[xx] > Es[best] + Math.max(2, gh * 0.006)) break;
      }
      return best;
    }
    var x0 = neckPoint(-1), x1 = neckPoint(1);
    if (x1 - x0 < bw * 0.15) return null;
    // Neckline bottom per column: through the inside of the shirt, then the front collar band and its stitching.
    var pxs = [], pys = [];
    for (x = x0; x <= x1; x++) {
      var y0 = E[x];
      if (y0 >= BIG) continue;
      var ref = [];
      for (y = Math.floor(y0 + gh * 0.2); y < Math.floor(y0 + gh * 0.26) && y < h; y++) ref.push(L[y * w + x]);
      var Lf = ref.length ? median(ref) : Lf0, lim = Math.min(ylim, y0 + Math.floor(gh * 0.08));
      k = y0;
      while (k < lim && Math.abs(L[k * w + x] - Lf) < tol) k++;
      if (k >= lim) continue;
      var cnt = 0;
      while (k < ylim) { cnt = Math.abs(L[k * w + x] - Lf) < tol ? cnt + 1 : 0; if (cnt >= run) break; k++; }
      if (k >= ylim) continue;
      var start = k - run + 1, end = start + rib;
      for (var q = start; q < Math.min(ylim, start + Math.floor(gh * 0.07)); q++) if (Math.abs(L[q * w + x] - Lf) >= tol) end = q + 2;
      if (start - y0 >= 3) { pxs.push(x); pys.push(end); }
    }
    if (pxs.length < (x1 - x0) * 0.3) return null;
    var xc = (x0 + x1) / 2;
    function U(xx) { return [1, xx - xc, (xx - xc) * (xx - xc)]; }
    function V(xx) { return [1, Math.abs(xx - xc), xx - xc]; }
    function robust(feat) {
      var keep = pxs.map(function () { return true; }), c = [0, 0, 0];
      for (var it = 0; it < 3; it++) {
        var rows = [], yy = [];
        pxs.forEach(function (xx, j) { if (keep[j]) { rows.push(feat(xx)); yy.push(pys[j]); } });
        if (rows.length < 3) break;
        c = lsq3(rows, yy);
        var res = pxs.map(function (xx, j) { var f = feat(xx); return pys[j] - (c[0] * f[0] + c[1] * f[1] + c[2] * f[2]); });
        var mad = median(res.filter(function (v, j) { return keep[j]; }).map(Math.abs)) + 1;
        keep = res.map(function (v) { return Math.abs(v) < 2.5 * mad; });
      }
      return c;
    }
    var cu = robust(U), cv = robust(V);
    function evalc(c, f) { return c[0] * f[0] + c[1] * f[1] + c[2] * f[2]; }
    // Generous cover: the fitted neckline + margin, and never less than a U as deep as the neck is wide (v-necks).
    var margin = Math.floor(rib * 2), pad = Math.max(3, Math.floor(bw * 0.03)), hw = (x1 - x0) / 2, ytop = Math.min(Es[x0], Es[x1]);
    // A smooth top edge across the neck (a white label on a white background must not read as a gap).
    var ex = [], ey = [];
    for (x = x0; x <= x1; x++) if (E[x] < BIG) { ex.push(x); ey.push(E[x]); }
    var keepE = ex.map(function () { return true; }), ce = [ytop, 0, 0];
    for (var itE = 0; itE < 3 && ex.length >= 3; itE++) {
      var rowsE = [], yyE = [];
      ex.forEach(function (xx, j) { if (keepE[j]) { rowsE.push(U(xx)); yyE.push(ey[j]); } });
      if (rowsE.length < 3) break;
      ce = lsq3(rowsE, yyE);
      var resE = ex.map(function (xx, j) { return ey[j] - evalc(ce, U(xx)); });
      var madE = median(resE.filter(function (v, j) { return keepE[j]; }).map(Math.abs)) + 1;
      keepE = resE.map(function (v) { return Math.abs(v) < 2.5 * madE; });
    }
    var mask = new Uint8Array(N), ylo = h, yhi = 0, xlo = w, xhi = 0;
    for (x = Math.max(0, x0 - pad); x <= Math.min(w - 1, x1 + pad); x++) {
      var inside = x >= x0 && x <= x1;
      if (inside) E[x] = Math.max(top, Math.round(Math.min(E[x], evalc(ce, U(x)))));
      if (E[x] >= BIG) continue;
      var xx2 = Math.min(Math.max(x, x0), x1);
      var yb = Math.max(evalc(cu, U(xx2)), evalc(cv, V(xx2)));
      var gen = ytop + 1.25 * (x1 - x0) * Math.max(0, 1 - Math.pow((xx2 - xc) / hw, 2));
      yb = Math.min(h - 1, Math.floor(Math.max(yb + margin, gen)));
      for (y = E[x]; y <= yb; y++) if (inside || fg[y * w + x]) { mask[y * w + x] = 1; if (y < ylo) ylo = y; if (y > yhi) yhi = y; if (x < xlo) xlo = x; if (x > xhi) xhi = x; }
    }
    if (yhi <= ylo) return null;
    // Fill: diffuse colour in from the surrounding fabric (background and soft edge pixels don't count).
    var core = new Uint8Array(N);
    for (y = 2; y < h - 2; y++) for (x = 2; x < w - 2; x++) {
      var all = 1;
      for (var dy = -2; dy <= 2 && all; dy++) for (var dx = -2; dx <= 2; dx++) if (!fg[(y + dy) * w + x + dx]) { all = 0; break; }
      core[y * w + x] = all;
    }
    var by0 = Math.max(0, ylo - 2), by1 = Math.min(h, yhi + 3), bx0 = Math.max(0, xlo - 2), bx1 = Math.min(w, xhi + 3);
    var SW = bx1 - bx0, SH = by1 - by0, SN = SW * SH;
    var sub = [new Float32Array(SN), new Float32Array(SN), new Float32Array(SN)], m = new Uint8Array(SN), valid = new Uint8Array(SN);
    for (y = 0; y < SH; y++) for (x = 0; x < SW; x++) {
      var gi = (y + by0) * w + x + bx0, si = y * SW + x;
      for (k = 0; k < 3; k++) sub[k][si] = data[gi * 4 + k];
      m[si] = mask[gi]; valid[si] = mask[gi] || core[gi] ? 1 : 0;
    }
    for (x = 0; x < SW; x++) {
      var maxr = -1;
      for (y = 0; y < SH; y++) if (m[y * SW + x]) maxr = y;
      if (maxr < 0) continue;
      var srow = Math.min(SH - 1, maxr + 1);
      for (y = 0; y <= maxr; y++) if (m[y * SW + x]) for (k = 0; k < 3; k++) sub[k][y * SW + x] = sub[k][srow * SW + x];
    }
    var idx = [];
    for (i = 0; i < SN; i++) if (m[i]) idx.push(i);
    var nb = [-1, 1, -SW, SW];
    for (var iter = 0; iter < 200; iter++) {
      for (var t2 = 0; t2 < idx.length; t2++) {
        var p = idx[t2], px_ = p % SW, acc0 = 0, acc1 = 0, acc2 = 0, c2 = 0;
        for (var d = 0; d < 4; d++) {
          var qn = p + nb[d];
          if (qn < 0 || qn >= SN || (d === 0 && px_ === 0) || (d === 1 && px_ === SW - 1) || !valid[qn]) continue;
          acc0 += sub[0][qn]; acc1 += sub[1][qn]; acc2 += sub[2][qn]; c2++;
        }
        if (c2) { sub[0][p] = acc0 / c2; sub[1][p] = acc1 / c2; sub[2][p] = acc2 / c2; }
      }
    }
    // Fine fabric texture from further down the garment, kept gentle.
    var depth = (yhi - ylo) + Math.floor(gh * 0.15);
    if (by1 + depth <= h) {
      var lim2 = 2.5 * sd + 2;
      for (k = 0; k < 3; k++) {
        var srcC = new Float32Array(SN);
        for (y = 0; y < SH; y++) for (x = 0; x < SW; x++) srcC[y * SW + x] = data[((y + by0 + depth) * w + x + bx0) * 4 + k];
        var bl3 = boxBlur(srcC, SW, SH, 3);
        for (t2 = 0; t2 < idx.length; t2++) {
          var pi = idx[t2], gy = Math.floor(pi / SW) + by0 + depth, gx = pi % SW + bx0;
          if (!core[gy * w + gx]) continue;
          sub[k][pi] += 0.7 * Math.max(-lim2, Math.min(lim2, srcC[pi] - bl3[pi]));
        }
      }
    }
    // Back collar: a soft stitch line just below the top edge.
    for (x = x0; x <= x1; x++) {
      if (E[x] >= BIG) continue;
      y = E[x] + Math.floor(rib * 0.9);
      if (y >= by0 && y < by1 && x >= bx0 && x < bx1 && m[(y - by0) * SW + x - bx0]) for (k = 0; k < 3; k++) sub[k][(y - by0) * SW + x - bx0] *= 0.94;
    }
    var mf = new Float32Array(N);
    for (i = 0; i < N; i++) mf[i] = mask[i];
    var mm = boxBlur(mf, w, h, 1);
    var overlay = new Uint8ClampedArray(N * 4);
    for (y = by0; y < by1; y++) for (x = bx0; x < bx1; x++) {
      var gi2 = y * w + x, si2 = (y - by0) * SW + x - bx0;
      if (mm[gi2] <= 0.001) continue;
      for (k = 0; k < 3; k++) overlay[gi2 * 4 + k] = m[si2] ? sub[k][si2] : data[gi2 * 4 + k];
      overlay[gi2 * 4 + 3] = Math.round(mm[gi2] * 255);
    }
    return { overlay: overlay, box: { x: bx0, y: by0, w: SW, h: SH }, neck: { x0: x0, x1: x1 } };
  }

  /*
   * Find a sleeve on a flat front packshot and frame a close-up of it.
   * which: 'left' = the wearer's left sleeve (on the right of a front photo), 'right' = the wearer's right.
   * frontAreaW: the front print area width in cm (the garment body width in the photo), which sets the scale.
   * Returns { crop: {x, y, w, h} in px of this image, zone: {zoneLeft, zoneTop, zoneWidth} and box: {l, t, r, b}
   * in % of the crop } or null when no sleeve can be found (e.g. a vest or a model photo).
   */
  function sleeveFromFront(data, w, h, which, frontAreaW, areaW, areaH, opts) {
    var N = w * h, x, y, i;
    var cs = [[2, 2], [w - 3, 2], [2, h - 3], [w - 3, h - 3]], bg = [0, 1, 2].map(function (c) {
      var v = cs.map(function (p) { return data[(p[1] * w + p[0]) * 4 + c]; }).sort(function (a, b) { return a - b; }); return (v[1] + v[2]) / 2;
    });
    var fg = new Uint8Array(N);
    for (i = 0; i < N; i++) fg[i] = Math.abs(data[i * 4] - bg[0]) + Math.abs(data[i * 4 + 1] - bg[1]) + Math.abs(data[i * 4 + 2] - bg[2]) > 36 ? 1 : 0;
    var top = -1, bot = -1;
    for (y = 0; y < h; y++) { var n = 0; for (x = 0; x < w; x++) n += fg[y * w + x]; if (n > 2) { if (top < 0) top = y; bot = y; } }
    if (top < 0) return null;
    var gh = bot - top, cx = Math.floor(w / 2);
    if (gh < h * 0.3) return null;
    // body width below the sleeves: must read the same at several heights (white-on-white photos often don't)
    var runs = [];
    [0.62, 0.68, 0.74, 0.8].forEach(function (f) {
      var yy = Math.floor(top + gh * f), a = cx, b = cx;
      if (!fg[yy * w + cx]) return;
      while (a > 0 && fg[yy * w + a - 1]) a--;
      while (b < w - 1 && fg[yy * w + b + 1]) b++;
      runs.push([a, b]);
    });
    if (runs.length < 4) return null;
    // the body edge should run smoothly down the shirt (fitted shirts flare a little at a time);
    // a jump means the outline was lost, e.g. a white shirt on a white background
    var widths = runs.map(function (r2) { return r2[1] - r2[0] + 1; });
    for (var wi = 1; wi < widths.length; wi++) {
      if (Math.abs(widths[wi] - widths[wi - 1]) > widths[0] * 0.08) return null;
    }
    var ym = Math.floor(top + gh * 0.62), bl = runs[0][0], br = runs[0][1];
    var bw = br - bl + 1;
    // Long sleeves hanging against the body (see garmentFit): take the body edges from where the arms hang clear,
    // and the sleeve from the shoulder down to about half way (the upper arm).
    var sp = splitBody(function (sx, sy) { return fg[sy * w + sx] === 1; }, w, top, gh, cx), longArm = false;
    if (sp && sp[1] - sp[0] + 1 < bw * 0.93) { bl = sp[0]; br = sp[1]; bw = br - bl + 1; longArm = true; }
    else if (!sp && opts && opts.longSleeve) {
      // arms never hang clear: if the middle run is nearly the whole outline, it has the arms in it
      var ol = w, orr = -1;
      for (y = top; y <= bot; y += 2) for (x = 0; x < w; x++) if (fg[y * w + x]) { if (x < ol) ol = x; if (x > orr) orr = x; }
      if (bw >= 0.85 * (orr - ol + 1)) return null;
    }
    if (bw < w * 0.2) return null;
    // armpit: going up from the middle, the first row where the garment gets clearly wider than the body
    var ya = -1;
    for (y = ym; y > top; y--) {
      var l = cx, r = cx;
      while (l > 0 && fg[y * w + l - 1]) l--;
      while (r < w - 1 && fg[y * w + r + 1]) r++;
      if (r - l + 1 > bw * 1.12) { ya = y; break; }
    }
    if (ya < 0 || ya - top < gh * 0.08) return null;
    // the sleeve: garment pixels outside the body line, from the top down to a little below the armpit
    var edge = which === 'left' ? br : bl, ylim = Math.min(bot, longArm ? top + Math.floor(gh * 0.5) : ya + Math.floor(gh * 0.12));
    var sx0 = w, sx1 = -1, sy0 = h, sy1 = -1, cnt = 0, mx = 0, my = 0;
    for (y = top; y <= ylim; y++) for (x = 0; x < w; x++) {
      if (!fg[y * w + x]) continue;
      if (which === 'left' ? x <= edge + 1 : x >= edge - 1) continue;
      cnt++; mx += x; my += y;
      if (x < sx0) sx0 = x; if (x > sx1) sx1 = x; if (y < sy0) sy0 = y; if (y > sy1) sy1 = y;
    }
    if (cnt < bw * gh * 0.01 || sx1 - sx0 < bw * 0.08) return null;
    mx /= cnt; my /= cnt;
    var pxcm = bw / frontAreaW;
    // frame: the sleeve plus a margin, 5:6 like the product photos
    var sw = sx1 - sx0 + 1, sh = sy1 - sy0 + 1;
    var cw = Math.max(sw * 1.35, sh * 1.35 * 5 / 6, areaW * pxcm * 1.3), ch = cw * 6 / 5;
    // centred on the sleeve; where the frame runs past the photo it is filled with the background colour
    var ccx = (sx0 + sx1) / 2, ccy = (sy0 + sy1) / 2;
    var x0 = ccx - cw / 2, y0 = Math.max(0, Math.min(h - ch, ccy - ch / 2));
    var zw = areaW * pxcm, zh = areaH * pxcm;
    return {
      crop: { x: x0, y: y0, w: cw, h: ch },
      bg: 'rgb(' + bg.map(Math.round).join(',') + ')',
      zone: { zoneLeft: (mx - zw / 2 - x0) / cw * 100, zoneTop: (my - zh / 2 - y0) / ch * 100, zoneWidth: zw / cw * 100 },
      box: { l: (sx0 - x0) / cw * 100, t: (sy0 - y0) / ch * 100, r: (sx1 + 1 - x0) / cw * 100, b: (sy1 + 1 - y0) / ch * 100 }
    };
  }

  /* ----- Rotation ----- */

  function normAngle(deg) { var a = (deg || 0) % 360; if (a < 0) a += 360; return Math.round(a * 10) / 10 % 360; }

  // Width and height of the space a w × h print takes up when rotated by deg.
  function rotatedExtent(w, h, deg) {
    var r = (deg || 0) * Math.PI / 180, c = Math.abs(Math.cos(r)), s = Math.abs(Math.sin(r));
    if (c < 1e-9) c = 0; if (s < 1e-9) s = 0;
    return { w: w * c + h * s, h: w * s + h * c };
  }

  // The rotated print's footprint (axis-aligned box around it), same centre as the print.
  function occupiedBox(p) {
    var e = rotatedExtent(p.w, p.h, p.rot);
    return { x: p.x + p.w / 2 - e.w / 2, y: p.y + p.h / 2 - e.h / 2, w: e.w, h: e.h };
  }

  // Largest artwork (proportions kept) whose rotated footprint fits the size tier and the area.
  function fitRotated(aspect, tier, area, deg) {
    var e = rotatedExtent(1, 1 / aspect, deg);  // footprint of a 1 cm wide print
    var w = Math.min(Math.min(tier.maxW, area.w) / e.w, Math.min(tier.maxH, area.h) / e.h);
    return { w: w, h: w / aspect };
  }

  // Snap to 0/90/180/270 when within tol degrees.
  function snapAngle(deg, tol) {
    var a = normAngle(deg), q = Math.round(a / 90) * 90;
    return Math.abs(a - q) <= (tol == null ? 4 : tol) ? q % 360 : a;
  }

  function angleText(deg) {
    var a = normAngle(deg);
    if (!a) return 'not rotated';
    if (a === 180) return 'rotated 180° (upside down)';
    return a < 180 ? 'rotated ' + round1(a) + '° clockwise' : 'rotated ' + round1(360 - a) + '° anticlockwise';
  }

  /* ----- Text prints ----- */

  var DEFAULT_FONTS = 'Montserrat:800\nAnton\nBebas Neue\nGraduate\nBlack Ops One\nPermanent Marker\nPacifico\nGreat Vibes\nSpecial Elite\nCinzel:700';
  var DEFAULT_COLOURS = 'Black #000000\nWhite #FFFFFF\nRed #D7262E\nNavy #1F2A44\nRoyal blue #1F5BC6\nBottle green #1E5631\nYellow #FFD100\nOrange #F47B20\nPink #F06EAA\nPurple #6A3D9A\nGold #C9A227\nGrey #A7A9AC';

  // "Anton\nMontserrat:800" -> [{ family: 'Anton', weight: 400 }, { family: 'Montserrat', weight: 800 }]
  function parseFonts(text) {
    var out = [];
    String(text || '').split(/[\n,;]/).forEach(function (line) {
      var m = line.match(/^\s*([A-Za-z0-9][A-Za-z0-9 ]*?)\s*(?::\s*(\d{3}))?\s*$/);
      if (m && !out.some(function (f) { return f.family === m[1]; })) out.push({ family: m[1], weight: m[2] ? parseInt(m[2], 10) : 400 });
    });
    return out;
  }

  // "Black #000000\nRed: #D7262E" -> [{ name: 'Black', hex: '#000000' }, ...]
  function parseColours(text) {
    var out = [];
    String(text || '').split(/[\n,;]/).forEach(function (line) {
      var m = line.match(/^\s*(.+?)\s*[:=]?\s*(#[0-9a-fA-F]{6})\s*$/);
      if (m) out.push({ name: m[1], hex: m[2].toUpperCase() });
    });
    return out;
  }

  function fontsCssUrl(fonts) {
    return 'https://fonts.googleapis.com/css2?' + fonts.map(function (f) {
      return 'family=' + f.family.replace(/ /g, '+') + (f.weight && f.weight !== 400 ? ':wght@' + f.weight : '');
    }).join('&') + '&display=swap';
  }

  function textLines(value) {
    return String(value || '').replace(/\r/g, '').split('\n');
  }

  function effectivePpi(usablePx, printedCm) {
    if (!printedCm) return 0;
    return usablePx / (printedCm / 2.54);
  }

  function pxNeeded(cm, ppi) {
    return Math.ceil((cm / 2.54) * ppi);
  }

  function resolutionLevel(ppi, good, warn) {
    if (ppi >= good) return 'good';
    if (ppi >= warn) return 'ok';
    return 'low';
  }

  // { chargeVariantId: count } for one garment.
  function chargeCounts(prints, sizesByKey) {
    var counts = {};
    prints.forEach(function (p) {
      var s = sizesByKey[p.sizeKey];
      if (!s || !s.variantId) return;
      counts[s.variantId] = (counts[s.variantId] || 0) + 1;
    });
    return counts;
  }

  function printsPrice(prints, sizesByKey) {
    var total = 0;
    prints.forEach(function (p) {
      var s = sizesByKey[p.sizeKey];
      if (s && s.price != null) total += s.price;
    });
    return total;
  }

  function boxesOverlap(a, b) {
    return a.x < b.x + b.w && b.x < a.x + a.w && a.y < b.y + b.h && b.y < a.y + a.h;
  }

  // "XS:26, S:28, M:30" -> { XS: 26, S: 28, M: 30 }
  function parseSizeScale(text) {
    var out = {};
    String(text || '').split(/[,;\n]/).forEach(function (part) {
      var m = part.match(/^\s*([^:]+?)\s*:\s*(\d+(?:\.\d+)?)\s*$/);
      if (m) out[m[1].trim().toUpperCase()] = parseFloat(m[2]);
    });
    return out;
  }

  // "20:5, 50:10, 100:20" -> [{ min: 20, pct: 5 }, ...] sorted by min
  function parseTiers(text) {
    var out = [];
    String(text || '').split(/[,;\n]/).forEach(function (part) {
      var m = part.match(/^\s*(\d+)\s*:\s*(\d+(?:\.\d+)?)\s*$/);
      if (m) out.push({ min: parseInt(m[1], 10), pct: parseFloat(m[2]) });
    });
    return out.sort(function (a, b) { return a.min - b.min; });
  }

  // Size lookup for the scale table: exact name, then the first half of a combined size
  // ("S/M" -> S), then a catch-all "*" entry. null = not scaled.
  function scaleLookup(scale, sizeName) {
    var k = String(sizeName == null ? '' : sizeName).trim().toUpperCase();
    if (scale[k] != null) return scale[k];
    if (k.indexOf('/') > 0) {
      var first = k.split('/')[0].trim();
      if (scale[first] != null && /[A-Z]/.test(first)) return scale[first];
    }
    return scale['*'] != null ? scale['*'] : null;
  }

  // Which print sizes a position offers. allowedText: "Medium" or "Medium, Large"; blank = all.
  function tierAllowed(allowedText, label) {
    var list = String(allowedText || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    return !list.length || list.indexOf(String(label || '').trim().toLowerCase()) !== -1;
  }

  // Largest print a tier gives on a position (tier limits capped by the print area).
  function effectiveTier(tier, side) {
    return { w: Math.min(tier.maxW, side.areaW), h: Math.min(tier.maxH, side.areaH) };
  }

  function bulkInfo(count, tiers) {
    var current = null, next = null;
    tiers.forEach(function (t) {
      if (count >= t.min) current = t;
      else if (!next) next = t;
    });
    return { current: current, next: next, need: next ? next.min - count : 0 };
  }

  /*
   * The print as it will be printed on a given garment size. The print area shrinks with the size (maxWidthForSize is
   * that size's widest print); the print keeps its cm size where it fits and is scaled down (proportions kept) where it
   * doesn't; its position scales with the garment. Then (review point 2, 18 Oct 2026) the rotated footprint is checked
   * against the smaller area: a print that would poke out is moved back inside, and shrunk if it still can't fit.
   * Returns { x, y, w, h } of the artwork box, foot: its footprint, areaW/areaH, scaled, moved: { x, y } in cm, note.
   * p.rot (degrees) is honoured; p.w/p.h are the unrotated artwork size.
   */
  function scaleForSize(p, side, maxWidthForSize) {
    var f = maxWidthForSize ? Math.min(1, maxWidthForSize / side.areaW) : 1;
    var areaW = side.areaW * f, areaH = side.areaH * f;
    var rot = p.rot || 0;
    var ext = rotatedExtent(p.w, p.h, rot);
    // Scale down only as far as the footprint needs to fit the smaller area.
    var s = Math.min(1, areaW / ext.w, areaH / ext.h);
    var w = p.w * s, h = p.h * s;
    var centreOffset = (p.x + p.w / 2 - side.areaW / 2) * f;
    var cx = areaW / 2 + centreOffset, cy = (p.y + p.h / 2) * f;
    var fe = rotatedExtent(w, h, rot);
    // Keep the footprint inside the area: move the centre back in (the area is at least as big as the footprint now).
    var ncx = Math.min(Math.max(cx, fe.w / 2), Math.max(areaW - fe.w / 2, fe.w / 2));
    var ncy = Math.min(Math.max(cy, fe.h / 2), Math.max(areaH - fe.h / 2, fe.h / 2));
    var moved = { x: round1(ncx - cx), y: round1(ncy - cy) };
    var scaled = s < 0.999;
    var notes = [];
    if (scaled) notes.push('scaled down to ' + round1(w).toFixed(1) + ' × ' + round1(h).toFixed(1) + ' cm');
    if (Math.abs(moved.x) >= 0.05 || Math.abs(moved.y) >= 0.05) {
      var parts = [];
      if (Math.abs(moved.x) >= 0.05) parts.push(Math.abs(moved.x).toFixed(1) + ' cm ' + (moved.x > 0 ? 'right' : 'left'));
      if (Math.abs(moved.y) >= 0.05) parts.push(Math.abs(moved.y).toFixed(1) + ' cm ' + (moved.y > 0 ? 'down' : 'up'));
      notes.push('moved ' + parts.join(' and ') + ' to stay inside the print area');
    } else moved = { x: 0, y: 0 };
    return {
      x: ncx - w / 2, y: ncy - h / 2, w: w, h: h, rot: rot,
      foot: { x: ncx - fe.w / 2, y: ncy - fe.h / 2, w: fe.w, h: fe.h },
      areaW: areaW, areaH: areaH, scaled: scaled, moved: moved, note: notes.join('; ')
    };
  }

  // Is the print's rotated footprint inside its position's print area (cm, with a small tolerance)?
  function footprintWithin(p, side, tol) {
    var t = tol == null ? 0.05 : tol;
    var ob = occupiedBox(p);
    return ob.x >= -t && ob.y >= -t && ob.x + ob.w <= side.areaW + t && ob.y + ob.h <= side.areaH + t;
  }

  /*
   * Boundary check before anything is added to the basket (review point 4): every print must sit inside its position's
   * approved print area as placed, and its scaled placement must for every ordered size. prints: [{ uid, side, x, y, w,
   * h, rot, art }], sides: { key: side }, sizeNames: ordered garment sizes, maxWidthFor(size) -> cm or null.
   * Returns a list of plain-English problems (empty = fine).
   */
  function validatePrints(prints, sides, sizeNames, maxWidthFor, sizesByKey) {
    var out = [];
    (prints || []).forEach(function (p, i) {
      if (!p.art) return;
      var side = sides[p.side];
      if (!side) { out.push('Print ' + (i + 1) + ' has no print position.'); return; }
      if (!footprintWithin(p, side)) {
        out.push('Print ' + (i + 1) + ' doesn’t fit inside the ' + side.name.toLowerCase() + ' print area (' + round1(side.areaW) + ' × ' + round1(side.areaH) + ' cm). Make it smaller or move it inside the dashed box.');
        return;
      }
      (sizeNames || []).forEach(function (sz) {
        var sp = scaleForSize(p, side, maxWidthFor ? maxWidthFor(sz) : null);
        var ft = sp.foot;
        if (ft.x < -0.05 || ft.y < -0.05 || ft.x + ft.w > sp.areaW + 0.05 || ft.y + ft.h > sp.areaH + 0.05) {
          out.push('Print ' + (i + 1) + ' can’t fit the ' + side.name.toLowerCase() + ' print area on size ' + sz + '. Make it smaller.');
        }
      });
    });
    return out;
  }

  function placementText(sp, side, sizeName) {
    var ft = sp.foot || sp;
    var centreOffset = round1(sp.x + sp.w / 2 - sp.areaW / 2);
    var dir = centreOffset === 0 ? 'on the centre line' : Math.abs(centreOffset).toFixed(1) + ' cm ' + (centreOffset > 0 ? 'right' : 'left') + ' of centre (as worn: ' + (centreOffset > 0 ? "wearer's left" : "wearer's right") + ')';
    var outside = ft.x < -0.05 || ft.y < -0.05 || ft.x + ft.w > sp.areaW + 0.05 || ft.y + ft.h > sp.areaH + 0.05;
    return (
      (sizeName ? 'Size ' + sizeName + ': ' : '') +
      'top-left at ' + round1(ft.x).toFixed(1) + ' cm across, ' + round1(ft.y).toFixed(1) + ' cm down from the top-left of the ' +
      side.name.toLowerCase() + ' print area (' + round1(sp.areaW) + ' × ' + round1(sp.areaH) + ' cm, ' + side.anchor + ')' +
      (outside ? ' – placed partly outside that area (negative = left of / above it), check on the mock-up' : '') + '. ' +
      'Print centre ' + dir + '. ' + (sp.rotNote ? 'Takes up ' : 'Size ') + round1(ft.w).toFixed(1) + ' × ' + round1(ft.h).toFixed(1) + ' cm' +
      (sp.rotNote ? ' (the artwork is ' + sp.rotNote + ' about its centre)' : '') + '.' +
      (sp.note ? ' Adjusted for this size: ' + sp.note + '.' : '')
    );
  }

  /*
   * Order totals. lines: [{ price, qty, designId }], designs: { id: prints[] }.
   * Bulk count = garments (+ print units if the bulk discount also covers prints).
   */
  function orderTotals(lines, designPrints, sizesByKey, tiers, bulkEligible, includePrints) {
    var garments = 0, garmentTotal = 0, printTotal = 0, printUnits = 0;
    lines.forEach(function (l) {
      var prints = designPrints[l.designId] || [];
      garments += l.qty;
      garmentTotal += l.price * l.qty;
      printTotal += printsPrice(prints, sizesByKey) * l.qty;
      printUnits += prints.length * l.qty;
    });
    var bulkCount = bulkEligible ? garments + (includePrints ? printUnits : 0) : 0;
    var info = bulkInfo(bulkCount, bulkEligible ? tiers : []);
    var discountBase = garmentTotal + (includePrints ? printTotal : 0);
    var discount = info.current ? Math.round(discountBase * info.current.pct / 100) : 0;
    return {
      garments: garments, garmentTotal: garmentTotal, printTotal: printTotal, printUnits: printUnits,
      subtotal: garmentTotal + printTotal, bulkCount: bulkCount, bulk: info, discount: discount,
      total: garmentTotal + printTotal - discount
    };
  }

  function makeRef() {
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var out = '';
    var bytes = new Uint8Array(8);
    (root.crypto || { getRandomValues: function (b) { for (var i = 0; i < b.length; i++) b[i] = Math.floor(Math.random() * 256); return b; } }).getRandomValues(bytes);
    for (var i = 0; i < bytes.length; i++) out += chars[bytes[i] % chars.length];
    return 'ISG-' + out;
  }

  function sniffType(bytes) {
    if (bytes.length >= 8 && bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47) return 'image/png';
    if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return 'image/jpeg';
    return null;
  }

  function alphaBounds(data, width, height, threshold) {
    var minX = width, minY = height, maxX = -1, maxY = -1;
    for (var y = 0; y < height; y++) {
      var row = y * width * 4;
      for (var x = 0; x < width; x++) {
        if (data[row + x * 4 + 3] > threshold) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return null;
    return { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 };
  }

  /* ----- Calibration (review point 3, 18 Oct 2026): garment measurements are separate from printable dimensions ----- */

  var GARMENT_MODES = { garment: 1, 'garment-long': 1, 'garment-hood': 1 };

  /*
   * 'calibrated' when the template carries real figures measured on the garment: garmentWidthCm (half-chest, side seam
   * to side seam, of the size shown in the photos), collarToPrintCm (top of the garment to the top of the print area) and
   * referenceSize (the size photographed). Otherwise 'estimated': the photo's body width is taken as the print area width,
   * which is the pre-review behaviour and is only a rough guide. Non-garment shapes return 'n/a'.
   */
  function calibrationStatus(settings) {
    var s = settings || {};
    if (!GARMENT_MODES[s.fitMode || 'garment']) return 'n/a';
    var gw = parseFloat(s.garmentWidthCm), cp = parseFloat(s.collarToPrintCm);
    if (gw > 0 && cp >= 0 && !isNaN(cp) && String(s.referenceSize || '').trim()) return 'calibrated';
    return 'estimated';
  }

  /*
   * Where a garment's print area sits on a measured photo. fit: garmentFit's result (zoneLeft/zoneWidth = the body, side
   * seam to side seam, in % of the photo width; box.t = the top of the garment in % of the height). side: areaW/areaH in cm.
   * calib: { garmentWidthCm, collarToPrintCm } or null. stageAspect = photo width / height.
   * Calibrated: 1 cm = (body % / garmentWidthCm) of the photo width; the print area is areaW cm wide, centred on the body,
   * and starts collarToPrintCm below the garment's top. Uncalibrated: the body is taken as the print area (estimated: true).
   */
  function garmentZone(fit, side, calib, stageAspect) {
    var gw = calib && parseFloat(calib.garmentWidthCm), cp = calib && parseFloat(calib.collarToPrintCm);
    if (!(gw > 0) || isNaN(cp) || cp < 0) {
      return { zoneLeft: fit.zoneLeft, zoneTop: fit.zoneTop, zoneWidth: fit.zoneWidth, box: fit.box, estimated: true };
    }
    var pctPerCm = fit.zoneWidth / gw;             // % of photo width per cm
    var zw = side.areaW * pctPerCm;
    var centre = fit.zoneLeft + fit.zoneWidth / 2;
    var top = (fit.box ? fit.box.t : fit.zoneTop) + cp * pctPerCm * (stageAspect || 1);
    var out = { zoneLeft: centre - zw / 2, zoneTop: top, zoneWidth: zw, box: fit.box, estimated: false, pctPerCm: pctPerCm };
    if (side.areaW > gw + 1e-9) out.error = 'print area width (' + side.areaW + ' cm) is wider than the garment (' + gw + ' cm)';
    return out;
  }

  /* ----- Rollback verification (review point 5): lines of earlier failed attempts still in the cart ----- */
  function leftoverLines(cart, refBases) {
    var out = [];
    if (!cart || !cart.items || !refBases || !refBases.length) return out;
    cart.items.forEach(function (it) {
      var ref = it.properties && it.properties['Design ref'];
      if (!ref) return;
      for (var i = 0; i < refBases.length; i++) if (ref.indexOf(refBases[i] + '-') === 0 || ref === refBases[i]) { out.push(it.key); return; }
    });
    return out;
  }

  /* ----- Previews per colour (review point 6) ----- */
  // One upload group per design and colour, in line order: [{ designId, colour, lines }].
  function uploadGroups(lines) {
    var out = [], idx = {};
    (lines || []).forEach(function (l) {
      var k = l.designId + '|' + l.colour;
      if (idx[k] == null) { idx[k] = out.length; out.push({ designId: l.designId, colour: l.colour, lines: [] }); }
      out[idx[k]].lines.push(l);
    });
    return out;
  }

  function previewNote(colour, referenceSize, lineSize) {
    var ref = referenceSize ? 'the size ' + referenceSize + ' photo' : 'the product photo';
    return 'Previews show ' + colour + ' on ' + ref + (lineSize ? '. This line is size ' + lineSize + (referenceSize && lineSize !== referenceSize ? ': the printed sizes above are what will be printed on it' : '') : '') + '.';
  }

  /* ----- Placement verification gate ----- */
  // Verified only when ISG has confirmed the placement: the product's isg.placement_verified field, or every print
  // position used is marked "verified" on a template whose scale is not merely estimated.
  function placementVerified(data, usedSideKeys, calibStatus) {
    if (!data) return false;
    if (data.placementVerified === true || (data.placement && data.placement.verified === true)) return true;
    if (calibStatus === 'estimated') return false;
    var sides = {};
    (data.sides || []).forEach(function (s) { sides[s.key] = s; });
    var keys = usedSideKeys || Object.keys(sides);
    if (!keys.length) return false;
    for (var i = 0; i < keys.length; i++) { var s = sides[keys[i]]; if (!s || s.areaStatus !== 'verified') return false; }
    return true;
  }

  var helpers = {
    money: money, round1: round1, fitToTier: fitToTier, clampBox: clampBox, effectivePpi: effectivePpi,
    footprintWithin: footprintWithin, validatePrints: validatePrints, calibrationStatus: calibrationStatus, garmentZone: garmentZone,
    leftoverLines: leftoverLines, uploadGroups: uploadGroups, previewNote: previewNote, placementVerified: placementVerified,
    pxNeeded: pxNeeded, resolutionLevel: resolutionLevel, chargeCounts: chargeCounts, printsPrice: printsPrice,
    boxesOverlap: boxesOverlap, parseSizeScale: parseSizeScale, parseTiers: parseTiers, bulkInfo: bulkInfo,
    scaleForSize: scaleForSize, placementText: placementText, orderTotals: orderTotals, makeRef: makeRef,
    sniffType: sniffType, alphaBounds: alphaBounds, scaleLookup: scaleLookup, tierAllowed: tierAllowed, effectiveTier: effectiveTier,
    clampToBounds: clampToBounds, stageBounds: stageBounds, garmentFit: garmentFit, pctBoxToCm: pctBoxToCm,
    normAngle: normAngle, rotatedExtent: rotatedExtent, occupiedBox: occupiedBox, fitRotated: fitRotated, snapAngle: snapAngle,
    angleText: angleText, parseFonts: parseFonts, parseColours: parseColours, fontsCssUrl: fontsCssUrl, textLines: textLines,
    DEFAULT_FONTS: DEFAULT_FONTS, DEFAULT_COLOURS: DEFAULT_COLOURS,
    backFromFront: backFromFront, boxBlur: boxBlur, sleeveFromFront: sleeveFromFront,
    parseCmPair: parseCmPair, parseSizedPairs: parseSizedPairs, bagBody: bagBody, bagFit: bagFit, bagPlace: bagPlace,
    endPlace: endPlace, chestZone: chestZone, headwearFit: headwearFit, legFit: legFit, hivisFit: hivisFit, apronFit: apronFit
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = helpers;
    return;
  }

  /* ---------- Browser UI ---------- */

  var doc = root.document;
  var LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  function el(tag, attrs, children) {
    var node = doc.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v == null || v === false) return;
        if (k === 'class') node.className = v;
        else if (k === 'text') node.textContent = v;
        else if (k.indexOf('on') === 0 && typeof v === 'function') node.addEventListener(k.slice(2), v);
        else node.setAttribute(k, v === true ? '' : v);
      });
    }
    (children || []).forEach(function (c) {
      if (c == null) return;
      node.appendChild(typeof c === 'string' ? doc.createTextNode(c) : c);
    });
    return node;
  }

  function readHead(file) {
    return file.slice(0, 16).arrayBuffer().then(function (buf) { return new Uint8Array(buf); });
  }

  function loadImage(src, cross) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (cross) img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('image-load')); };
      img.src = src;
    });
  }

  // Measure usable (non-transparent) area. Reads a scaled copy; the original file is untouched.
  function analyseArtwork(type, img) {
    var w = img.naturalWidth, h = img.naturalHeight;
    var full = { x: 0, y: 0, w: w, h: h };
    if (type !== 'image/png') return { bbox: full, trimmed: false };
    var scale = Math.min(1, 1200 / Math.max(w, h));
    var cw = Math.max(1, Math.round(w * scale)), ch = Math.max(1, Math.round(h * scale));
    try {
      var c = doc.createElement('canvas');
      c.width = cw; c.height = ch;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, cw, ch);
      var b = alphaBounds(ctx.getImageData(0, 0, cw, ch).data, cw, ch, 8);
      if (!b) return { bbox: null, trimmed: false, empty: true };
      var x0 = Math.max(0, Math.floor(b.x / scale));
      var y0 = Math.max(0, Math.floor(b.y / scale));
      var x1 = Math.min(w, Math.ceil((b.x + b.w) / scale));
      var y1 = Math.min(h, Math.ceil((b.y + b.h) / scale));
      var bbox = { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
      return { bbox: bbox, trimmed: bbox.w < w || bbox.h < h };
    } catch (e) {
      return { bbox: full, trimmed: false };
    }
  }

  function xhrPost(url, body, onProgress) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      if (onProgress && xhr.upload) xhr.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded / e.total); };
      xhr.onload = function () {
        var json = null;
        try { json = JSON.parse(xhr.responseText); } catch (e) { /* not JSON */ }
        if (xhr.status >= 200 && xhr.status < 300 && json) resolve(json);
        else reject({ status: xhr.status, json: json });
      };
      xhr.onerror = function () { reject({ status: 0 }); };
      xhr.ontimeout = function () { reject({ status: 0, timeout: true }); };
      xhr.timeout = 300000;
      xhr.send(body);
    });
  }

  function requestJson(url, payload) {
    return fetch(url, {
      method: payload ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-ISG-Sync': '1' },
      body: payload ? JSON.stringify(payload) : undefined
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw { status: r.status, json: j }; return j; });
    });
  }

  // Draw text on a canvas (transparent background) at fontPx, trimmed to the ink. Returns the canvas.
  function drawText(t, fontPx) {
    var lines = textLines(t.value);
    var font = (t.weight || 400) + ' ' + fontPx + 'px "' + t.family + '", sans-serif';
    var m = doc.createElement('canvas').getContext('2d');
    m.font = font;
    var widths = lines.map(function (l) { return m.measureText(l).width; });
    var maxW = Math.max.apply(null, widths.concat([1]));
    var lh = fontPx * 1.25, pad = Math.ceil(fontPx * 0.6);
    var c = doc.createElement('canvas');
    c.width = Math.ceil(maxW + pad * 2); c.height = Math.ceil(lines.length * lh + pad * 2);
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.font = font; ctx.fillStyle = t.colour; ctx.textBaseline = 'alphabetic';
    lines.forEach(function (l, i) {
      var x = t.align === 'left' ? pad : t.align === 'right' ? pad + maxW - widths[i] : pad + (maxW - widths[i]) / 2;
      ctx.fillText(l, x, pad + i * lh + fontPx * 0.95);
    });
    var b = alphaBounds(ctx.getImageData(0, 0, c.width, c.height).data, c.width, c.height, 0);
    if (!b) return null;
    var out = doc.createElement('canvas');
    out.width = b.w; out.height = b.h;
    out.getContext('2d').drawImage(c, b.x, b.y, b.w, b.h, 0, 0, b.w, b.h);
    out.srcW = c.width; out.srcH = c.height;
    return out;
  }

  function isStoredUpload(value) {
    return typeof value === 'string' && /^(https?:)?\/\//.test(value) && value.indexOf('blob:') !== 0;
  }

  /* hand-over to the next part */
  NS.backFromFront = backFromFront;
  NS.sleeveFromFront = sleeveFromFront;
  NS.normAngle = normAngle;
  NS.rotatedExtent = rotatedExtent;
  NS.occupiedBox = occupiedBox;
  NS.fitRotated = fitRotated;
  NS.snapAngle = snapAngle;
  NS.angleText = angleText;
  NS.DEFAULT_FONTS = DEFAULT_FONTS;
  NS.DEFAULT_COLOURS = DEFAULT_COLOURS;
  NS.parseFonts = parseFonts;
  NS.parseColours = parseColours;
  NS.fontsCssUrl = fontsCssUrl;
  NS.textLines = textLines;
  NS.effectivePpi = effectivePpi;
  NS.pxNeeded = pxNeeded;
  NS.resolutionLevel = resolutionLevel;
  NS.chargeCounts = chargeCounts;
  NS.printsPrice = printsPrice;
  NS.boxesOverlap = boxesOverlap;
  NS.parseSizeScale = parseSizeScale;
  NS.parseTiers = parseTiers;
  NS.scaleLookup = scaleLookup;
  NS.tierAllowed = tierAllowed;
  NS.effectiveTier = effectiveTier;
  NS.scaleForSize = scaleForSize;
  NS.validatePrints = validatePrints;
  NS.placementText = placementText;
  NS.orderTotals = orderTotals;
  NS.makeRef = makeRef;
  NS.sniffType = sniffType;
  NS.calibrationStatus = calibrationStatus;
  NS.garmentZone = garmentZone;
  NS.leftoverLines = leftoverLines;
  NS.uploadGroups = uploadGroups;
  NS.previewNote = previewNote;
  NS.placementVerified = placementVerified;
  NS.doc = doc;
  NS.LETTERS = LETTERS;
  NS.el = el;
  NS.readHead = readHead;
  NS.loadImage = loadImage;
  NS.analyseArtwork = analyseArtwork;
  NS.xhrPost = xhrPost;
  NS.requestJson = requestJson;
  NS.drawText = drawText;
  NS.isStoredUpload = isStoredUpload;
  NS.__parts = 2;
})(typeof window !== 'undefined' ? window : globalThis);
